import { render, staticRenderFns } from "./set13.vue?vue&type=template&id=6bd0763a&scoped=true&"
import script from "./set13.vue?vue&type=script&lang=js&"
export * from "./set13.vue?vue&type=script&lang=js&"
import style0 from "./set13.vue?vue&type=style&index=0&id=6bd0763a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd0763a",
  null
  
)

export default component.exports